"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.legacy = exports.Errors = exports.DepGraphBuilder = exports.createFromJSON = void 0;
var create_from_json_1 = require("./core/create-from-json");
Object.defineProperty(exports, "createFromJSON", { enumerable: true, get: function () { return create_from_json_1.createFromJSON; } });
var builder_1 = require("./core/builder");
Object.defineProperty(exports, "DepGraphBuilder", { enumerable: true, get: function () { return builder_1.DepGraphBuilder; } });
const Errors = require("./core/errors");
exports.Errors = Errors;
const legacy = require("./legacy");
exports.legacy = legacy;
//# sourceMappingURL=index.js.map